import { render, staticRenderFns } from "./recipientAnticipationSettings.vue?vue&type=template&id=65b09012"
import script from "./recipientAnticipationSettings.vue?vue&type=script&lang=js"
export * from "./recipientAnticipationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports